import { Backdrop, Grid, Modal, Typography, useTheme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { OrangeButton } from 'components/Button';
import { translate } from 'helpers/intl';
import { AssuranceIcon } from 'images';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import labels from 'utils/labels';
import useStyles from './styles';

interface Props {
  intl: IntlShape;
  open: boolean;
  setOpen: (value: boolean) => void;
  onAccessAmcClick: () => void;
  onAccessOtherSpacesClick: () => void;
}

const SpacesModal = ({
  open,
  setOpen,
  onAccessAmcClick,
  onAccessOtherSpacesClick,
  ...props
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles(isMobile);

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={() => setOpen(false)}
      closeAfterTransition
      BackdropComponent={Backdrop}
      disableBackdropClick
      BackdropProps={{
        timeout: 500,
        classes: { root: classes.backdrop },
      }}
    >
      <Grid className={classes.paper}>
        <Grid className={classes.header}>
          <Grid className={classes.titleContainer} xs={12}>
            <Typography className={classes.header_title}>
              {translate({ id: labels.chooseSpace }, props)}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-evenly"
          className={classes.spacesContainer}
        >
          <Grid item xs={12} sm={5} className={classes.spaceContainer}>
            <Grid xs={12}>
              <Grid className={classes.spaceHeader}>
                <div className={classes.healthIconOval}>
                  <img
                    alt=""
                    src={AssuranceIcon.healthShape}
                    className={classes.icon}
                  />
                </div>
              </Grid>
              <Typography className={classes.amcTitle}>
                {translate({ id: labels.amcSpace }, props)}
              </Typography>
              {!isMobile && (
                <Grid>
                  <ul className={classes.list}>
                    <li>
                      {translate({ id: labels.trackFoldersHistory }, props)}
                    </li>
                    <li>
                      {translate(
                        { id: labels.consultAdhesionsAndContracts },
                        props,
                      )}
                    </li>
                    <li>
                      {translate(
                        { id: labels.reportMedicalFoldersOnline },
                        props,
                      )}
                    </li>
                    <li>{translate({ id: labels.reportPac }, props)}</li>
                    <li>
                      {translate({ id: labels.locateDropOffPoints }, props)}
                    </li>
                  </ul>
                </Grid>
              )}
            </Grid>
            <Grid
              container
              justify="center"
              className={classes.buttonContainer}
            >
              <Grid item sm={8} alignItems="center">
                <OrangeButton variant="contained" onClick={onAccessAmcClick}>
                  {translate({ id: labels.access }, props)}
                </OrangeButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={5} className={classes.spaceContainer}>
            <Grid xs={12}>
              <Grid className={classes.spaceHeader}>
                <img
                  alt="nec-icons"
                  src={AssuranceIcon.iconsNec}
                  className={classes.iconsNec}
                />
              </Grid>
              <Typography className={classes.spaceTitle}>
                {translate({ id: labels.autoRetailsSavingSpaces }, props)}
              </Typography>
              {!isMobile && (
                <Grid>
                  <ul className={classes.list}>
                    <li>{translate({ id: labels.trackClaims }, props)}</li>
                    <li>
                      {translate(
                        { id: labels.consultContractAndGuarantee },
                        props,
                      )}
                    </li>
                    <li>
                      {translate({ id: labels.consultSavingSituation }, props)}
                    </li>
                    <li>
                      {translate({ id: labels.accessSanlamServices }, props)}
                    </li>
                    <li>
                      {translate(
                        { id: labels.discoverPersonalizedOffers },
                        props,
                      )}
                    </li>
                  </ul>
                </Grid>
              )}
            </Grid>
            <Grid
              container
              justify="center"
              className={classes.buttonContainer}
            >
              <Grid item sm={8} alignItems="center">
                <OrangeButton
                  variant="contained"
                  onClick={onAccessOtherSpacesClick}
                >
                  {translate({ id: labels.access }, props)}
                </OrangeButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default injectIntl(SpacesModal);
